import AppTitle from '@components/app-content/app-title/AppTitle';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import React, { ReactNode } from 'react';

type Props = {
    title: string;
    routerPaths: string[];
    children: ReactNode;
};

export default function AppContentContainer({ title, routerPaths, children }: Props) {
    return (
        <div className='bg-white'>
            <div
                className={classnames(
                    'w-full',
                    !routerPaths.includes('selling-hours') && 'hidden',
                    'md:block'
                )}
            >
                <AppTitle Title={title} routerPath={routerPaths}></AppTitle>
            </div>
            <div className='w-full'>{children}</div>
        </div>
    );
}
